import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert"
import { Button } from "~/components/ui/button"
import { MessagesSquare } from "lucide-react"
import { Link } from "@remix-run/react"

export default function NoResultsAlert() {
  return (
    <Alert className="my-8 max-w-3xl mx-auto">
      <MessagesSquare className="h-4 w-4" />
      <AlertTitle>¿No encuentras lo que buscas?</AlertTitle>
      <AlertDescription className="flex items-center justify-between">
        <span>Cuéntanos qué tipo de espacio necesitas y te ayudaremos a encontrarlo.</span>
        <Button variant="outline" asChild>
          <Link to="/solicitar-espacio">Solicitar espacio</Link>
        </Button>
      </AlertDescription>
    </Alert>
  )
}
